/** ライブ契約数カウントアップAPI Mockレスポンス */
const CountUpCntLive = {
  onLiveCnt: 10,
  maxLive: 10,
  countup: 1,
};

export default CountUpCntLive;
